import React from 'react';
import { Provider } from 'react-redux';

import Polizas from './polizas.cmpt';


export default class Registro extends React.Component {
    render() {
        return <Provider store={this.props.redux}>
            <Polizas />
        </Provider>;
    }
}


// WEBPACK FOOTER //
// ./src/home/contenedor.cmpt.js